import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "columns", "columnSize", "gutterSize", "maxInlineSize", "nowrap", "style"];
let _ = t => t,
  _t,
  _t2,
  _t3;
import { device } from '../constants/StyledComponentConstants';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import styledWithTheme from 'foundations-theming/utils';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { jsx as _jsx } from "react/jsx-runtime";
export const CardGridWrapper = styledWithTheme.div(_t || (_t = _`
  @media screen and ${0} {
    &::-webkit-scrollbar {
      inline-size: ${0};
      background: transparent;
      block-size: ${0};
    }
  }

  overflow-x: auto;
  margin-inline-end: -${0};
  margin-inline-start: -${0};
  padding-inline-start: ${0};
  padding-inline-end: ${0};
  padding-block-start: ${0};
  margin-block-start: -${0};

  &.noBorder {
    .mobileCardScroll {
      border-block-end: 0;
    }
  }

  &.noPadding {
    .mobileCardScroll {
      padding-block-end: ${0};
    }
  }
`), device.mobile, ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['0']);
const MobileCardScrollFlex = styledWithTheme.div(_t2 || (_t2 = _`
  display: flex;
  max-inline-size: unset;
  inline-size: ${0}%;
  padding-inline-end: ${0};
  padding-block-end: ${0};
  margin-block-end: ${0};

  && > * {
    max-inline-size: ${0};

    &:only-child {
      max-inline-size: calc(100vw - 30px);
    }
  }
`), ({
  columns
}) => 85 * (columns || 2), ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.space['100'], props => props.maxInlineSize);
const CardRow = styledWithTheme.div(_t3 || (_t3 = _`
  display: flex;

  && > * {
    margin-inline-end: ${0}px;
    max-inline-size: ${0};
  }

  && > *:last-child {
    margin-inline-end: ${0};
  }

  max-inline-size: unset;
  min-inline-size: fit-content;
`), props => props.gutterSize, props => props.maxInlineSize, ({
  theme
}) => theme.space['0']);
const ResponsiveCardGridContainer = _ref => {
  let {
      children,
      className,
      columns,
      columnSize = 295,
      gutterSize = 32,
      maxInlineSize,
      nowrap,
      style
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile
  } = useMediaQuery();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(CardGridWrapper, {
      className: className,
      style: style,
      children: isMobile ?
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(MobileCardScrollFlex, {
        className: "mobileCardScroll",
        columns: columns,
        maxInlineSize: maxInlineSize ? `${maxInlineSize}px` : 'unset',
        children: children
      }) : nowrap ?
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(CardRow, {
        gutterSize: gutterSize,
        maxInlineSize: maxInlineSize ? `${maxInlineSize}px` : 'unset',
        children: children
      }) : /*#__PURE__*/_jsx(CardGrid, Object.assign({
        columnSize: columnSize,
        columns: columns,
        gutterSize: gutterSize,
        paddingBlockEnd: "800"
      }, restProps, {
        children: children
      }))
    })
  );
};
export default ResponsiveCardGridContainer;